export default {
	styleOverrides: {
		root: {
			paddingInline: 0,
			gap: '16px',
			'& .MuiButtonBase-root': {
				fontWeight: 600,
				flex: 1,
				margin: 0,
				borderRadius: '10px',
			},
		},
	},
};
